import {
  Text,
  Badge,
  Card,
  SwitchLineInput,
  GreyGrey70,
  Primary13Regular,
  Primary14SemiBold,
  Flex
} from '@sequencehq/core-components'
import { AvailableServices } from 'Integrations/domain'
import { getIntegrationName } from 'Integrations/utils/getIntegrationName'

type AutoLinkCustomersCardProps = {
  service: AvailableServices
  value: boolean
  /** Toggle is on but a parent level blocks the sync (resolved permission). */
  paused: boolean
  onChange: (value: boolean) => void
  isDisabled?: boolean
}

/**
 * Presentational "auto-link customers" setting. Stateless: the caller owns the
 * value, and every screen stages the change behind Save changes. What differs
 * between them is only how Save gets enabled.
 */
export const AutoLinkCustomersCard = ({
  service,
  value,
  paused,
  onChange,
  isDisabled
}: AutoLinkCustomersCardProps) => {
  const serviceName = getIntegrationName(service)

  return (
    <Card>
      <Flex flexDirection="column" gap="12px">
        <Flex alignItems="center" gap="8px">
          <Text {...Primary14SemiBold}>Customers</Text>
          {paused && (
            <Badge
              sentiment="neutral"
              data-testid="badge.autoLinkCustomers.paused"
            >
              Paused
            </Badge>
          )}
        </Flex>
        <SwitchLineInput
          data-testid="switch.autoLinkCustomers"
          value={value}
          isDisabled={isDisabled}
          onChange={onChange}
          text="Auto-link customers"
        />
        <Text
          {...Primary13Regular}
          color={GreyGrey70}
          data-testid="autoLinkCustomers.description"
        >
          {paused
            ? `Auto-linking is on, but syncing to ${serviceName} is currently paused by your sync settings and won't run until it's resumed.`
            : `Automatically push unlinked customers to ${serviceName} when an invoice or credit note is finalized.`}
        </Text>
      </Flex>
    </Card>
  )
}
